import type { ErrorInfo, PropsWithChildren, ReactNode } from 'react';
import { Component, use } from 'react';

import { reportErrorBoundaryError } from '@/_shared/utils/sentry-utils';

import { ErrorContext } from './error-boundary-context';

import { Button } from '../button';

interface Props {
  fallback: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
  errorInfo: ErrorInfo | null;
}

export class ErrorBoundary extends Component<PropsWithChildren<Props>, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error: Error, errorInfo: ErrorInfo) {
    return { hasError: true, error, errorInfo };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    this.setState({ hasError: true, error, errorInfo });

    // Report to Sentry
    reportErrorBoundaryError(error, errorInfo);
  }

  render() {
    const { children, fallback } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      console.log({ error: this.state.error, errorInfo: this.state.errorInfo });
      return <ErrorContext value="name">{fallback}</ErrorContext>;
    }

    return children;
  }
}

export function Retry() {
  const retry = () => {
    console.log('retry');
  };

  const key = use(ErrorContext);

  console.log(key);

  return (
    <div>
      <Button onClick={retry} size="sm">
        Retry
      </Button>
    </div>
  );
}
